const RANKING_ITEMS = [
  { rank: 1, title: '庆余年 第二季', tags: ['国产剧', '古装'], hot: '9.8', change: 'up' },
  { rank: 2, title: '长相思', tags: ['国产剧', '古装'], hot: '9.6', change: 'up' },
  { rank: 3, title: '眼泪女王', tags: ['韩剧', '爱情'], hot: '9.5', change: 'up' },
  { rank: 4, title: '与凤行', tags: ['国产剧', '仙侠'], hot: '9.3', change: 'same' },
  { rank: 5, title: '墨雨云间', tags: ['国产剧', '古装'], hot: '9.1', change: 'up' },
  { rank: 6, title: '狐妖小红娘月红篇', tags: ['国产剧', '奇幻'], hot: '8.9', change: 'down' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热播榜单</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            全网最热门电视剧全集实时排行，看看大家都在追什么
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {RANKING_ITEMS.map((item) => (
            <div
              key={item.rank}
              className="group flex items-center gap-4 bg-background-50 rounded-lg p-4 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg font-heading text-lg shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-foreground-900 text-sm truncate">{item.title}</h3>
                <div className="flex items-center gap-2 mt-1 flex-wrap">
                  {item.tags.map((tag) => (
                    <span key={tag} className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
              <div className="flex items-center gap-1 shrink-0">
                <span className="text-sm font-semibold text-primary-500">{item.hot}</span>
                <i className={`text-xs ${
                  item.change === 'up' ? 'ri-arrow-up-line text-green-500' :
                  item.change === 'down' ? 'ri-arrow-down-line text-red-500' :
                  'ri-subtract-line text-foreground-400'
                }`}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}